import React, { useEffect, useState } from "react";

const getRandomColor = (text) => {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 70%, 60%)`;
};

const Avatar = ({
  src,
  alt,
  size = 50,
  responsiveSize = {},
  className = "",
}) => {
  const [avatarSize, setAvatarSize] = useState(size);

  useEffect(() => {
    const updateSize = () => {
      let newSize = size;
      Object.entries(responsiveSize).forEach(([breakpoint, value]) => {
        if (window.innerWidth < parseInt(breakpoint)) {
          newSize = value;
        }
      });
      setAvatarSize(newSize);
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, [size, responsiveSize]);

  const fallbackText = alt ? alt.charAt(0).toUpperCase() : "?";
  const bgColor = getRandomColor(fallbackText);

  return (
    <div
      className={`relative flex items-center justify-center font-bold text-white uppercase rounded-full shadow-md ${className}`}
      style={{
        width: avatarSize,
        height: avatarSize,
        backgroundColor: src ? "transparent" : bgColor,
      }}>
      {src ? (
        <img
          src={src}
          alt={alt}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <span className="text-lg" style={{ fontSize: `${avatarSize / 2.2}px` }}>
          {fallbackText}
        </span>
      )}
    </div>
  );
};

export default Avatar;
